import React from 'react';

import constants from '../../utils/constants';
import styles from './styles.module.scss';

const Holder = () => {
  const {
    sites: { us },
  } = constants;
  const faqLink = `https://${us}/resource-center/finance/the-ultimate-guide-to-paycheck-protection-program-loans`;

  return (
    <section className={styles.section}>
      <div className="container">
        <div className={styles.standardBlock}>
          <h2>Have questions?</h2>
          <p>
            <a href={faqLink} target="_blank" rel="noopener noreferrer">
              Review our FAQs
            </a>{' '}
            or contact us at 888-351-3143 or{' '}
            <a
              href="mailto:ppp@kabbage.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              ppp@kabbage.com
            </a>{' '}
            if you don’t see the information you need.
          </p>
          <a
            href={faqLink}
            target="_blank"
            rel="noopener noreferrer"
            className="pill-button large green"
            aria-label="View FAQs to learn more about the Paycheck Protection Program"
          >
            View FAQs
          </a>
        </div>
        <div className={styles.altBlock}>
          <h3>Be aware of potential scams</h3>
          <p>
            We want to make sure you and your business are protected and get the
            critical funding you need during this crisis.{' '}
            <a href={faqLink} target="_blank" rel="noopener noreferrer">
              Review our FAQs
            </a>{' '}
            for signs of potential SBA fraud, which you can report{' '}
            <a
              href="https://www.sba.gov/about-sba/oversight-advocacy/office-inspector-general/office-inspector-general-hotline#section-header-0"
              target="_blank"
              rel="noopener noreferrer"
            >
              online
            </a>{' '}
            or through the Office of Inspector General’s hotline at
            800-767-0385.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Holder;
